import * as ActionTypes from './ActionTypes'

export function startDataLoad() {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNDATA_LOAD_MANAGER_START_DATA_LOAD,
    })
  }
}

export function setDataLoadInitiated() {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNDATA_LOAD_MANAGER_SET_DATA_LOAD_INITIATED,
    })
  }
}

export function endDataLoad() {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNDATA_LOAD_MANAGER_END_DATA_LOAD,
    })
  }
}

export function startBaseLoad() {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNDATA_LOAD_MANAGER_START_BASE_LOAD,
    })
  }
}

export function setBaseLoadInitiated() {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNDATA_LOAD_MANAGER_SET_BASE_LOAD_INITIATED,
    })
  }
}

export function endBaseLoad() {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNDATA_LOAD_MANAGER_END_BASE_LOAD,
    })
  }
}

export function resetBaseLoad() {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNDATA_LOAD_MANAGER_RESET_BASE_LOAD,
    })
  }
}

export function setSections(sections) {
  return (dispatch, getState) => {
    dispatch({
      type: ActionTypes.VNDATA_LOAD_MANAGER_SET_SECTIONS,
      sections,
    })
  }
}
